<script setup lang="ts">
  import { getCurrentInstance, onMounted } from "vue";
  import { storeToRefs } from "pinia";
  import { useRouter } from "vue-router";

  import { IndexPageLayout, IndexPageFilters } from "@/components/App/IndexPage";
  import MailingListsTable from "@/components/Mailing/MailingListsTable.vue";
  import { useMailingListsStore } from "@stores/survey/mailing/mailingLists";
  import type { Survey } from "@/types";

  const props = defineProps<{
    survey: Survey;
  }>();

  const router = useRouter();
  const mailingListsStore = useMailingListsStore();
  const { mailingListsSearchQuery } = storeToRefs(mailingListsStore);

  const navigateToNewList = () => {
    router.push(`/surveys/${props.survey.token}/mailing/lists/new`);
  };

  const instance = getCurrentInstance();
  const cable = instance?.proxy?.$cable;

  onMounted(() => {
    if (cable) {
      cable.subscribe({ channel: "BrevoChannel", survey_token: props.survey.token });
      cable._addChannel("BrevoChannel", mailingListsStore.brevoChannelHandlers(cable, props.survey.token), {
        _uid: instance?.uid,
        _value: instance?.proxy,
      });
    }
  });
</script>

<template>
  <IndexPageLayout
    title="Lists"
    data-cy="survey-mailing-lists-page"
    action-label="New list"
    @action="navigateToNewList">
    <template #filters>
      <IndexPageFilters
        v-model:search-model-value="mailingListsSearchQuery"
        search-placeholder="Search lists" />
    </template>

    <MailingListsTable />
  </IndexPageLayout>
</template>
